import axios from 'axios';
import { Workspace } from '../models/common-types';

export interface WorkspacesApi {
    fetchAssignedWorkspaces(): Promise<Workspace[]>;
    fetchAllworkspaces(): Promise<Workspace[]>;
    createWorkspcae(WorkspaceData: any): Promise<Workspace>;
    deleteWorkspace(id: any): Promise<object>;
    updateWorkspcae(wsId: number, WorkspaceData: any);
    getUsersAssignedToWorkspace(wsId: number): Promise<any>;
}

const baseUrl = '/api/osint/workspaces';

export class WorkspacesAPI implements WorkspacesApi {
    async getUsersAssignedToWorkspace(wsId: number) {
        const { data } = await axios.get(`${baseUrl}/${wsId}/users`);
        return data;
    }

    async createWorkspcae(WorkspaceData): Promise<Workspace> {
        try {
            const { data } = await axios.post<Workspace>(baseUrl, WorkspaceData);
            return data;
        } catch (error) {
            return null;
        }
    }
    async updateWorkspcae(wsId: number, WorkspaceData: any): Promise<any> {
        try {
            const response = await axios.put<Workspace>(`${baseUrl}/${wsId}`, WorkspaceData);
            return response;
        } catch (error) {
            return null;
        }
    }

    async fetchAllworkspaces(): Promise<Workspace[]> {
        try {
            const { data } = await axios.get<Workspace[]>(baseUrl);
            return data;
        } catch (error) {
            return [];
        }
    }

    async fetchAssignedWorkspaces(fetchAll?: string): Promise<Workspace[]> {
        const { data } = await axios.get<Workspace[]>(`${baseUrl}/assigned`);
        return data;
    }

    async deleteWorkspace(id: any): Promise<object> {
        return await axios.delete<Workspace>(`${baseUrl}/${id}`);
    }
}
